<template>
  <div>
    <div
      class="zonghe"
      v-if="httpFinish"
    >
      <!-- 面包屑 -->
      <div class="crumbs">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>报表统计</el-breadcrumb-item>
          <el-breadcrumb-item>综合榜单</el-breadcrumb-item>
          <el-breadcrumb-item v-if="isDetail">{{userCrumbName}}的个人报表</el-breadcrumb-item>
          <el-breadcrumb-item v-if="isScoreMore">查看更多</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 搜索 -->
      <div class="top clearfix">
        <div class="fl">
          <el-button
            v-if="isDetail || isScoreMore"
            type="text"
            icon="el-icon-arrow-left"
            class="but-black"
            @click="back"
          >
            返 回
          </el-button>
          学年：
          <el-date-picker
            class="search-year"
            v-model="searchYear"
            value-format="yyyy"
            size="small"
            type="year"
            @change="selectLsit()"
          >
          </el-date-picker>
          学期： <el-select
            clearable
            v-model="searchTerm"
            size="small"
            @change="selectLsit()"
          >
            <template v-for="i of dic.schoolTerm">
              <el-option
                :key="i.id"
                :label="i.dicName"
                :value="i.dicCode"
              ></el-option>
            </template>
          </el-select>
          <span v-if="isScoreMore">
            搜索：<el-input
              type="text"
              style="width: 200px"
              v-model="searchKey"
              @change="selectLsit(1)"
              size="small"
              placeholder="请输入教师姓名"
              clearable
            ></el-input>
          </span>

        </div>
        <!-- <div class="fr">
        <el-button
          size="small"
          icon="iconfont icon-daochu"
        >导出</el-button>
      </div> -->
      </div>

      <!-- 报表 -->
      <div
        class="baobiao"
        v-if="!isDetail"
      >
        <!-- 教师专业发展综合积分排行榜 -->
        <all-score
          ref="allScoreRef"
          :searchYear="searchYear"
          :searchTerm="searchTerm"
          :searchKey="searchKey"
          :isDetail="isDetail"
          :isScoreMore="isScoreMore"
          @goDetail="goDetailFather"
          @scoreMore="goScoreMore"
        ></all-score>

        <div v-if="!isScoreMore">
          <!-- 教师基本信息统计 -->
          <div class="top2">
            <h1>教师基本信息统计：
            </h1>
            <div class="big-box clearfix">
              <university :educationList="census.educationList"></university>
              <gender :sexList="census.sexList"></gender>
              <age :teacherAgeList="census.teacherAgeList"></age>
              <length-teaching :teachingAgeList="census.teachingAgeList"></length-teaching>
            </div>
          </div>
          <!-- 获奖统计 -->
          <div class="top3 fl">
            <h1>获奖信息统计：
            </h1>
            <div class="big-box clearfix">
              <teachers-award
                :teacherAwardList="teacherAwardList"
                v-if="showTeacherAward"
              ></teachers-award>
              <student-award
                :studentAwardList="studentAwardList"
                v-if="showStudentAward"
              ></student-award>
            </div>
          </div>
          <!-- 活跃度统计 -->
          <div class="top4 fl">
            <h1>活跃度榜单：
            </h1>
            <div class="big-box clearfix">
              <hyd-table
                :searchTerm="searchTerm"
                :searchYear="searchYear"
              ></hyd-table>
            </div>
          </div>
        </div>

      </div>

      <!-- 个人详情 -->
      <div
        class="personal"
        v-if="isDetail"
      >
        <!-- 基本信息  综合能力-->
        <BaseInformation
          :baseInfo="baseInfo"
          :baseInfoScore="baseInfoScore"
          :scoreList="scoreList"
        />

        <!-- 指导学生获奖 -->
        <div class="clearfix">
          <div class="bg3 fl">
            <h1>指导学生获奖 <span>{{awardsScore}}分</span></h1>
            <div
              class="content"
              v-if="!studentAwardsList.length"
            >
              <img :src="blankUrl">
            </div>
            <div
              class="content"
              v-else
            >
              <div class="top clearfix">
                <div class="zhengshu fl">
                  <img
                    :src="getAwardsUrl"
                    alt=""
                  >
                </div>
                <div class="chenghao fl">
                  <h3
                    v-for="item of studentAwardsList"
                    :key="item.id"
                    @click="selectAwards(item.id,item.awardAttach)"
                    :class="item.id===selectAwardsId ? 'yellow':''"
                  >{{item.awardName}}</h3>
                </div>
              </div>
              <div class="tu">
                <Awards :studentAwardsList="studentAwardsList" />
              </div>
            </div>
          </div>
          <!-- 个人荣誉 -->
          <div class="bg3 fl">
            <h1>个人荣誉 <span>{{honorScore}}分</span></h1>
            <div
              class="content"
              v-if="!honorList.length"
            >
              <img :src="blankUrl">
            </div>
            <div
              class="content"
              v-else
            >
              <div class="top clearfix">
                <div class="zhengshu fl">
                  <img
                    :src="getHonorUrl"
                    alt=""
                  >
                </div>
                <div class="chenghao fl">
                  <h3
                    v-for="item of honorList"
                    :key="item.id"
                    @click="selectHonor(item.id,item.honorAttach)"
                    :class="item.id===selectHonorId ? 'yellow':''"
                  >{{item.honorName}}</h3>
                </div>
              </div>
              <div class="tu">
                <Honour :honorList="honorList" />
              </div>
            </div>
          </div>
        </div>

        <div class="clearfix">
          <!-- 教师培训 -->
          <div class="bg3 fl">
            <h1>教师培训 <span>{{trainingScore}}分</span></h1>
            <div
              class="content"
              v-if="!trainingList.length"
            >
              <img :src="blankUrl">
            </div>
            <div
              class="content"
              v-else
            >
              <div class="tu1">
                <TeachersPxTop :trainingList="trainingList" />
              </div>
              <div class="tu2">
                <TeachersPxBot :trainingList="trainingList" />
              </div>
            </div>
          </div>
          <!-- 研修成果 -->
          <div class="bg3 fl">
            <h1>研修成果 <span>{{researchScore || "0"}}分</span></h1>
            <div
              class="content"
              v-if="!researchList.length"
            >
              <img :src="blankUrl">
            </div>
            <div
              class="content"
              v-else
            >
              <div class="tu1">
                <TeachersKyTop :researchList="researchList" />
              </div>
              <div class="tu2">
                <TeachersKyBot :researchList="researchList" />
              </div>
            </div>
          </div>
        </div>

        <!-- 小卡片 -->
        <div class="clearfix">
          <template
            v-for="(item,index) of cardObjList"
            :index="index"
          >
            <MinCard
              :key="index"
              :cardObj="item"
            />
          </template>
          <MidCard :midCardObjList="midCardObjList" />
        </div>

      </div>

    </div>
    <div
      v-loading="!loading"
      v-if="!httpFinish"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.9)"
      class="loding"
    >
    </div>
  </div>

</template>

<script>
import AllScore from "@/components/echarts/AllScore.vue";
import University from "@/components/echarts/University.vue";
import Gender from "@/components/echarts/Gender.vue";
import Age from "@/components/echarts/Age.vue";
import LengthTeaching from "@/components/echarts/LengthTeaching";

import TeachersAward from "@/components/echarts/TeachersAward";
import StudentAward from "@/components/echarts/StudentAward";
import HydTable from "@/components/echarts/table/HydTable";

// 个人报表
import BaseInformation from "@/components/echarts/personal/BaseInformation";
import Awards from "@/components/echarts/personal/Awards";
import Honour from "@/components/echarts/personal/Honour";
import TeachersPxTop from "@/components/echarts/personal/TeachersPxTop";
import TeachersPxBot from "@/components/echarts/personal/TeachersPxBot";
import TeachersKyTop from "@/components/echarts/personal/TeachersKyTop";
import TeachersKyBot from "@/components/echarts/personal/TeachersKyBot";
import MinCard from "@/components/echarts/personal/MinCard";
import MidCard from "@/components/echarts/personal/MidCard";
import { mapState } from "vuex";

export default {
  components: {
    AllScore,
    University,
    Gender,
    Age,
    LengthTeaching,
    TeachersAward,
    StudentAward,
    HydTable,
    BaseInformation,
    Awards,
    Honour,
    TeachersPxTop,
    TeachersPxBot,
    TeachersKyTop,
    TeachersKyBot,
    MinCard,
    MidCard,
  },
  computed: {
    ...mapState(["isAdmin", "userInfo", "dic"]),
    userCrumbName() {
      if (this.baseInfo) {
        let userCrNameObj = this.baseInfo.find(
          (item) => item.name == "教师基本信息"
        );
        if (userCrNameObj) {
          return userCrNameObj.data.userName;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    getAwardsUrl() {
      let fileAwardsSuffix = this.selectAwardsUrl.replace(/.+\./, "");
      if (
        ["png", "jpeg", "jpg"].indexOf(fileAwardsSuffix.toLowerCase()) != -1
      ) {
        return this.selectAwardsUrl;
      } else {
        return this.defaultUrl;
      }
    },
    getHonorUrl() {
      let fileHonorSuffix = this.selectHonorUrl.replace(/.+\./, "");
      if (["png", "jpeg", "jpg"].indexOf(fileHonorSuffix.toLowerCase()) != -1) {
        return this.selectHonorUrl;
      } else {
        return this.defaultUrl;
      }
    },
  },
  data() {
    return {
      searchYear: "",
      searchTerm: "",
      searchKey: "",
      isDetail: false,

      isScoreMore: false,
      defaultUrl: require(`@/assets/image/echarts/no.png`),

      blankUrl: require(`@/assets/image/echarts/noBiao.png`),
      cardObjList: [],
      midCardObjList: [],
      ///////////////////综合榜单报表，/////
      httpFinish: false,
      //学历性别年龄教龄
      census: {
        educationList: "",
        sexList: "",
        teacherAgeList: "",
        teachingAgeList: "",
      },
      //获奖隐藏
      showTeacherAward: false,
      showStudentAward: false,
      //学生获奖
      studentAwardList: "",
      //教师获奖
      teacherAwardList: "",
      ///////////////////个人报表，/////
      loading: false,
      //基本信息，小卡片
      baseInfo: "",
      baseInfoScore: "",
      teacherId: "",
      scoreList: "", //综合能力积分
      //指导学生获奖
      studentAwardsList: "",
      awardsScore: 0,
      selectAwardsId: "",
      selectAwardsUrl: "",
      //个人荣誉
      honorList: "",
      honorScore: 0,
      selectHonorId: "",
      selectHonorUrl: "",
      //教师培训
      trainingList: "",
      trainingScore: 0,
      //研修成果
      researchList: "",
      researchScore: 0,
    };
  },
  created() {

    this.searchYear = this.curYearPro;
    this.searchTerm = this.curTermPro;
    //学历 ，性别 ,年龄 ，教龄
    var p50 = new Promise((resolve, reject) => {
      let homeForm = {
        clientPackage: "com.xueduoduo.teacher.archives.pc",
        schoolCode: this.userInfo.schoolCode,
      };
      this.$axios
        .post("/rpt/getTeacherInfoList", this.$qs.stringify(homeForm))
        .then((res) => {
          if (res.resultCode === 200) {
            this.census = res.data;
            resolve("true");
          } else {
            reject(res.msg);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
    // 学生获奖
    var p51 = new Promise((resolve, reject) => {
      let homeForm = {
        clientPackage: "com.xueduoduo.teacher.archives.pc",
        schoolCode: this.userInfo.schoolCode,
        schoolTerm: this.searchTerm || "",
        schoolYear: this.searchYear || "",
      };
      this.$axios
        .post("/rpt/getTeacherAwardList", homeForm)
        .then((res) => {
          if (res.resultCode === 200) {
            this.studentAwardList = res.data;
            if (this.studentAwardList.length > 0) {
              this.studentAwardList = this.studentAwardList.filter(
                (item) => item.awardType2Desc
              );
            }
            this.showStudentAward = true;
            resolve("true");
          } else {
            reject(res.msg);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
    // 教师获奖
    var p52 = new Promise((resolve, reject) => {
      let homeForm = {
        clientPackage: "com.xueduoduo.teacher.archives.pc",
        schoolCode: this.userInfo.schoolCode,
        schoolTerm: this.searchTerm || "",
        schoolYear: this.searchYear || "",
      };
      this.$axios
        .post("/rpt/getTeacherHonorList", homeForm)
        .then((res) => {
          if (res.resultCode === 200) {
            this.teacherAwardList = res.data;
            if (this.teacherAwardList.length > 0) {
              this.teacherAwardList = this.teacherAwardList.filter(
                (item) => item.honorType2Desc
              );
            }
            this.showTeacherAward = true;
            resolve("true");
          } else {
            reject(res.msg);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
    this.httpFinish = false;
    Promise.all([p50, p51, p52])
      .then((res) => {
        this.loading = false;
        this.httpFinish = true;
      })
      .catch((err) => {
        console.log("-----开始请求", err);
        this.$message({
          message: err,
          type: "error",
        });
      });
  },
  methods: {
    //学年，学期 筛选
    // 积分排行 教师，学生获奖统计
    selectLsit() {
      if (!this.isDetail) {
        this.$nextTick(() => {
          this.$refs.allScoreRef.rankLsit(1, 4);
        });
      }

      let chageForm = {
        clientPackage: "com.xueduoduo.teacher.archives.pc",
        schoolCode: this.userInfo.schoolCode,
        schoolTerm: this.searchTerm || "",
        schoolYear: this.searchYear || "",
      };
      this.showStudentAward = false;
      this.showTeacherAward = false;
      //学生获奖
      this.$axios
        .post("/rpt/getTeacherAwardList", chageForm)
        .then((res) => {
          if (res.resultCode === 200) {
            this.studentAwardList = res.data;
            if (this.studentAwardList.length > 0) {
              this.studentAwardList = this.studentAwardList.filter(
                (item) => item.awardType2Desc
              );
            }
            this.showStudentAward = true;
          } else {
            console.log("学生获奖统计");
          }
        })
        .catch((err) => {
          this.$message({
            message: err,
            type: "error",
          });
        });
      //教师获奖
      this.$axios
        .post("/rpt/getTeacherHonorList", chageForm)
        .then((res) => {
          if (res.resultCode === 200) {
            this.teacherAwardList = res.data;
            if (this.teacherAwardList.length > 0) {
              this.teacherAwardList = this.teacherAwardList.filter(
                (item) => item.honorType2Desc
              );
            }
            this.showTeacherAward = true;
          } else {
            console.log("教师获奖统计");
          }
        })
        .catch((err) => {
          this.$message({
            message: err,
            type: "error",
          });
        });
    },
    goDetailFather(teacherId, totalScore) {
      this.teacherId = teacherId;
      this.goDetailHttp();
    },
    //所有详情请求
    goDetailHttp() {
      //基本信息  和 小卡片
      var p1 = new Promise((resolve, reject) => {
        let homeForm = {
          clientPackage: "com.xueduoduo.teacher.archives.pc",
          schoolCode: this.userInfo.schoolCode,
          teacherId: this.teacherId || "",
          pageSize: 50,
          schoolTerm: this.searchTerm || "",
          schoolYear: this.searchYear || "",
        };
        this.$axios
          .post("/rpt/getTeacherReportById", homeForm)
          .then(({ resultCode, data, msg }) => {
            if (resultCode === 200) {
              this.baseInfo = data;
              this.cardObjList = data.filter(
                (item) =>
                  !["教师基本信息", "条线工作及常规", "德育评比"]
                    .toString()
                    .includes(item.name)
              );
              this.midCardObjList = data.filter((item) =>
                ["条线工作及常规", "德育评比"].toString().includes(item.name)
              );
              resolve("true");
            } else {
              reject(msg);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
      //综合能力积分报表
      var p2 = new Promise((resolve, reject) => {
        let homeForm = {
          clientPackage: "com.xueduoduo.teacher.archives.pc",
          schoolCode: this.userInfo.schoolCode,
          teacherId: this.teacherId || "",
          schoolTerm: this.searchTerm || "",
          schoolYear: this.searchYear || "",
          pageSize: 50,
        };
        this.$axios
          .post("/rpt/queryTeacherDetailScoreListById", homeForm)
          .then(({ resultCode, data, msg }) => {
            if (resultCode === 200) {
              this.scoreList = data;
              this.scoreList.forEach((item) => {
                item.value = item.totalScore;
                item.name = item.moduleType;
              });
              this.baseInfoScore = 0;
              if (this.scoreList[0]) {
                this.scoreList.forEach((item) => {
                  this.baseInfoScore = this.baseInfoScore + item.value;
                });
              }
              resolve("true");
            } else {
              reject(msg);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
      //教师指导学生获奖
      var p3 = new Promise((resolve, reject) => {
        let homeForm = {
          clientPackage: "com.xueduoduo.teacher.archives.pc",
          schoolCode: this.userInfo.schoolCode,
          teacherId: this.teacherId || "",
          schoolTerm: this.searchTerm || "",
          schoolYear: this.searchYear || "",
          pageSize: 50,
        };
        this.$axios
          .post("/rpt/getTeacherStudentAwardsListById", homeForm)
          .then(({ resultCode, data, msg }) => {
            if (resultCode === 200) {
              this.studentAwardsList = data.records;
              this.awardsScore = 0;
              this.studentAwardsList.forEach((item) => {
                this.awardsScore = this.awardsScore + item.score;
              });
              //设置默认显示图片
              if (this.studentAwardsList[0]) {
                this.selectAwardsUrl = this.studentAwardsList[0].awardAttach;
                this.selectAwardsId = this.studentAwardsList[0].id;
              }
              resolve("true");
            } else {
              reject(msg);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
      //个人荣誉
      var p4 = new Promise((resolve, reject) => {
        let homeForm = {
          clientPackage: "com.xueduoduo.teacher.archives.pc",
          schoolCode: this.userInfo.schoolCode,
          teacherId: this.teacherId || "",
          schoolTerm: this.searchTerm || "",
          schoolYear: this.searchYear || "",
          pageSize: 50,
        };
        this.$axios
          .post("/rpt/getTeacherHonorInfoListById", homeForm)
          .then(({ resultCode, data, msg }) => {
            if (resultCode === 200) {
              this.honorList = data.records;
              this.honorScore = 0;
              this.honorList.forEach((item) => {
                this.honorScore = this.honorScore + item.score;
              });
              //设置默认显示图片
              if (this.honorList[0]) {
                this.selectHonorUrl = this.honorList[0].honorAttach;
                this.selectHonorId = this.honorList[0].id;
              }
              resolve("true");
            } else {
              reject(msg);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
      //教师培训
      var p5 = new Promise((resolve, reject) => {
        let homeForm = {
          clientPackage: "com.xueduoduo.teacher.archives.pc",
          schoolCode: this.userInfo.schoolCode,
          teacherId: this.teacherId || "",
          schoolTerm: this.searchTerm || "",
          schoolYear: this.searchYear || "",
          pageSize: 50,
        };
        this.$axios
          .post("/rpt/getTeacherTrainingListById", homeForm)
          .then((res) => {
            if (res.resultCode === 200) {
              this.trainingList = res.data;
              this.trainingScore = 0;
              this.trainingList.forEach((item) => {
                this.trainingScore = this.trainingScore + item.score;
              });
              resolve("true");
            } else {
              reject(res.msg);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
      //研修成果
      var p6 = new Promise((resolve, reject) => {
        let homeForm = {
          clientPackage: "com.xueduoduo.teacher.archives.pc",
          schoolCode: this.userInfo.schoolCode,
          schoolTerm: this.searchTerm || "",
          schoolYear: this.searchYear || "",
          teacherId: this.teacherId || "",
          pageSize: 50,
        };
        this.$axios
          .post("/rpt/getTeacherResearchInfoById", homeForm)
          .then((res) => {
            //resType 教研分类：0：论文，1：课题，2：教学比武，3：公开教学  4:常规检查-优秀教案
            if (res.resultCode === 200) {
              this.researchList = res.data;
              this.researchScore = 0;
              this.researchList = this.researchList.filter(
                (item) => item.thesisNum
              );
              this.researchList.forEach((item) => {
                this.researchScore = this.researchScore + item.score;
                switch (item.resType) {
                  case "0":
                    item.name = "论文";
                    item.unit = "篇";
                    break;
                  case "1":
                    item.name = "课题";
                    item.unit = "个";
                    break;
                  case "2":
                    item.name = "比武课";
                    item.unit = "节";
                    break;
                  case "3":
                    item.name = "公开教学";
                    item.unit = "节";
                    break;
                  case "4":
                    item.name = "常规检查";
                    item.unit = "个";
                    break;
                  default:
                    item.name = "未知";
                    item.unit = "个";
                    break;
                }
              });
              resolve("true");
            } else {
              reject(res.msg);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
      this.httpFinish = false;
      this.loading = false;
      Promise.all([p1, p2, p3, p4, p5, p6])
        .then((res) => {
          this.isDetail = true;
          this.loading = true;
          this.httpFinish = true;
        })
        .catch((err) => {
          this.$message({
            message: err || "服务器繁忙，请稍后再试。",
            type: "error",
          });
          this.isDetail = false;
          this.loading = true;
          this.httpFinish = true;
        });
    },
    //积分排行查看更多
    goScoreMore() {
      this.isScoreMore = true;
    },
    //个人详情返回，，，或者 积分榜单返回
    back() {
      if (this.isScoreMore) {
        this.selectLsit();
        this.isScoreMore = false;
      }
      if (this.isDetail) {
        this.isDetail = false;
      }
    },
    selectAwards(id, url) {
      this.selectAwardsId = id;
      this.selectAwardsUrl = url;
    },
    selectHonor(id, url) {
      this.selectHonorId = id;
      this.selectHonorUrl = url;
    },
  },
  watch: {
    // 学年 ， 学期  ，变化   在 个人详情 的展示
    searchYear(newValue, oldValue) {
      this.isDetail && this.goDetailHttp();
    },
    searchTerm(newValue, oldValue) {
      this.isDetail && this.goDetailHttp();
    },
  },
};
</script>

<style lang="less" scoped>
.zonghe {
  padding: 18px;
  border-radius: 8px;
  overflow: hidden;
  .crumbs {
    height: 30px;
    .el-breadcrumb {
      font-size: 15px;
    }
  }
  .top {
    background: #fff;
    line-height: 60px;
    height: 60px;
    padding: 0px 20px;
    font-size: 15px;
    margin-bottom: 20px;
    border-radius: 8px;
    .el-select {
      margin-right: 20px;
    }
    /deep/.el-input {
      width: none !important;
      .el-input__inner {
        width: none !important;
      }
    }
    .but-black.el-button {
      background: #fff;
      color: #409eff;
      margin-right: 10px;
    }
    .el-button {
      background: @theme-color;
      color: #fff;
      font-size: 14px;
      /deep/.iconfont {
        font-size: 15px;
        margin-right: 5px;
      }
    }
  }
  // 管理员综合报表
  .baobiao {
    .top2 {
      h1 {
        height: 40px;
        line-height: 40px;
        font-size: 20px;
        color: @theme-color;
        span {
          width: 130px;
          padding: 0px 20px;
          font-size: 14px;
          color: @theme-color;
          i {
            font-size: 16px;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            line-height: 19px;
            text-align: center;
            color: rgb(253, 250, 250);
            background-color: @theme-color;
          }
        }
      }
      .big-box {
        margin-top: 15px;
      }
    }
    .top3 {
      h1 {
        height: 40px;
        line-height: 40px;
        font-size: 20px;
        color: @theme-color;
      }
      .big-box {
        margin-top: 15px;
      }
    }
    .top4 {
      h1 {
        height: 40px;
        line-height: 40px;
        font-size: 20px;
        color: @theme-color;
      }
      .big-box {
        box-sizing: border-box;
        width: 580px;
        margin-top: 15px;
        margin-bottom: 50px;
      }
    }
  }
  // 个人报表
  .personal {
    .bg3 {
      width: 580px;
      height: 830px;
      background: url("../../../../assets/image/echarts/bg2.png") no-repeat;
      margin-right: 20px;
      margin-bottom: 20px;
      h1 {
        height: 54px;
        line-height: 54px;
        font-size: 16px;
        font-weight: 500;
        padding-left: 35px;
        span {
          color: #597ef7;
          font-size: 22px;
          font-weight: 600;
          padding-left: 10px;
        }
      }
      .content {
        box-sizing: border-box;
        height: 775px;
        padding: 10px;
        img {
          width: 100%;
          height: 100%;
        }
        .top {
          height: 260px;
          .zhengshu {
            margin-top: 15px;
            width: 248px;
            height: 226px;
            border: 2px dashed @theme-color;
            border-radius: 7px;
            img {
              margin-top: 3px;
              margin-left: 8px;
              width: 228px;
              height: 216px;
            }
          }
          .chenghao {
            border: 1px dashed rgb(238, 236, 236);
            box-sizing: border-box;
            margin-left: 30px;
            width: 230px;
            height: 220px;
            overflow: auto;
            margin-top: 18px;
            h3 {
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden; /** 隐藏超出的内容 **/
              cursor: pointer;
              height: 40px;
              line-height: 40px;
              color: @hui-color;
              text-align: center;
              width: 100%;
              font-size: 14px;
              font-weight: 550;
            }
            h3:hover {
              color: #ffaa00;
            }
            .yellow {
              color: #ffaa00;
            }
            .red {
              color: #ff7250;
            }
          }
        }
        .tu {
          height: 470px;
        }
        .tu1 {
          height: 240px;
          margin-bottom: 20px;
        }
        .tu2 {
          height: 470px;
        }
      }
    }
  }
}
.loding {
  height: 100vh;
}
</style>
